import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';
import { StructureAnalysis } from './structureAnalysis';
import { StructureComponent } from './structureComponent';

export class ArchitecturalDesign {
    constructor(doc)
    {
		this.label = null;
		this.architecturalDesignCategoryType = null;
		this.architecturalDesignCategoryTypeOtherDescription = null;
		this.structuralDesignType = null;
		this.structuralDesignTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.architecturalDesignCategoryType = x.getStringElement(doc, "./ns:ArchitecturalDesignCategoryType");
		this.architecturalDesignCategoryTypeOtherDescription = x.getStringElement(doc, "./ns:ArchitecturalDesignCategoryTypeOtherDescription");
		this.structuralDesignType = x.getStringElement(doc, "./ns:StructuralDesignType");
		this.structuralDesignTypeOtherDescription = x.getStringElement(doc, "./ns:StructuralDesignTypeOtherDescription");
   }
}

export class ConstructionMethod {
  constructor(doc)
    {
		this.label = null;
		this.constructionMethodType = null;
		this.constructionMethodTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.constructionMethodType = x.getStringElement(doc, "./ns:ConstructionMethodType");
		this.constructionMethodTypeOtherDescription = x.getStringElement(doc, "./ns:ConstructionMethodTypeOtherDescription");
		}

		GetMethodType() {
			return h.descriptionOrOther(this.constructionMethodType, this.constructionMethodTypeOtherDescription);
		}

}

export class StructureDetail {
    constructor(doc)
    {
		this.label = null;
		this.atticExistsIndicator = null;
		this.exteriorConditionRatingCode = null;
		this.exteriorQualityRatingCode = null;
		this.factoryBuiltCertificationExaminedIndicator = null;
		this.frontDoorApproximateElevationRangeType = null;
		this.livingUnitCount = null;
		this.rowhouseTownhouseBackToBackIndicator = null;
		this.rowhouseTownhouseEndUnitIndicator = null;
		this.rowhouseTownhouseLocationType = null;
		this.rowhouseTownhouseStackedIndicator = null;
		this.storiesCount = null;
		this.structureAreaMeasure = null;
		this.structureExcludingVehicleStorageAndADUFinishedAreaMeasure = null;
		this.structureExcludingVehicleStorageAndADUUnfinishedAreaMeasure = null;
		this.structureIdentifier = null;
		this.structureNonContinuousFinishedAreaMeasure = null;
		this.structureValuationCommentText = null;
		this.structureVolumeMeasure = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.atticExistsIndicator = x.getBooleanElement(doc, "./ns:AtticExistsIndicator");
		this.exteriorConditionRatingCode = x.getStringElement(doc, "./ns:ExteriorConditionRatingCode");
		this.exteriorQualityRatingCode = x.getStringElement(doc, "./ns:ExteriorQualityRatingCode");
		this.factoryBuiltCertificationExaminedIndicator = x.getBooleanElement(doc, "./ns:FactoryBuiltCertificationExaminedIndicator");
		this.frontDoorApproximateElevationRangeType = x.getStringElement(doc, "./ns:FrontDoorApproximateElevationRangeType");
		this.livingUnitCount = x.getIntegerElement(doc, "./ns:LivingUnitCount");
		this.rowhouseTownhouseBackToBackIndicator = x.getBooleanElement(doc, "./ns:RowhouseTownhouseBackToBackIndicator");
		this.rowhouseTownhouseEndUnitIndicator = x.getBooleanElement(doc, "./ns:RowhouseTownhouseEndUnitIndicator");
		this.rowhouseTownhouseLocationType = x.getStringElement(doc, "./ns:RowhouseTownhouseLocationType");
		this.rowhouseTownhouseStackedIndicator = x.getBooleanElement(doc, "./ns:RowhouseTownhouseStackedIndicator");
		this.storiesCount = x.getIntegerElement(doc, "./ns:StoriesCount");
		this.structureAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:StructureAreaMeasure");
		this.structureExcludingVehicleStorageAndADUFinishedAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:StructureExcludingVehicleStorageAndADUFinishedAreaMeasure");
		this.structureExcludingVehicleStorageAndADUUnfinishedAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:StructureExcludingVehicleStorageAndADUUnfinishedAreaMeasure");
		this.structureIdentifier = x.getStringElement(doc, "./ns:StructureIdentifier");
		this.structureNonContinuousFinishedAreaMeasure = x.getMISMOMeasureElement(doc, "./ns:StructureNonContinuousFinishedAreaMeasure");
		this.structureValuationCommentText = x.getStringElement(doc, "./ns:StructureValuationCommentText");
		this.structureVolumeMeasure = x.getMISMOMeasureElement(doc, "./ns:StructureVolumeMeasure");
   }
}

export class Structure {
    constructor(doc)
    {
		this.label = null;
		this.architecturalDesign = null;
		this.constructionMethods = [];
		this.structureAnalysis = null;
		this.structureComponents = [];
		this.structureDetail = null;
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:ARCHITECTURAL_DESIGN");
		if (node !== null)
				this.architecturalDesign = new ArchitecturalDesign(node);
		nodes = x.selectNodes(doc, "./ns:CONSTRUCTION_METHODS/ns:CONSTRUCTION_METHOD");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.constructionMethods.push(new ConstructionMethod(xn));
			});
		}

		node = x.selectSingleNode(doc, "./ns:STRUCTURE_ANALYSES/ns:STRUCTURE_ANALYSIS");
		if (node !== null)
				this.structureAnalysis = (new StructureAnalysis(node));

		nodes = x.selectNodes(doc, "./ns:STRUCTURE_COMPONENTS/ns:STRUCTURE_COMPONENT");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.structureComponents.push(new StructureComponent(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:STRUCTURE_DETAIL");
		if (node !== null)
				this.structureDetail = new StructureDetail(node);
   }

	GetFeatureDetail(type) {
			let feature = null;
			if (!this.structureComponents) return null;

			for (const sc of this.structureComponents) {
					if (sc.structureComponentDetail.improvementComponentType === type) {
							feature = sc.GetFeatureList();
							if (type === "Windows") {
									feature.detail = sc.structureComponentDetail.improvementComponentTypeAdditionalDescription;
							}
					}
			}

			return feature;
	}

	GetFeatures() {
			if (!this.structureComponents) return null;

			const features = [];
			for (const sc of this.structureComponents) {
					var feature = this.GetFeatureDetail(sc.structureComponentDetail.improvementComponentType);
					features.push(feature);
					//console.log(sc, feature);
			}

			return features;
	}

	GetStructureComponent(type) {
			if (!this.structureComponents) return null;

			for (const sc of this.structureComponents) {
					if (sc.structureComponentDetail.improvementComponentType === type) {
							return sc;
					}
			}

			return null;
	}

	GetWallMaterials() { // Exterior quality
			let methods = "";
			if (!this.structureComponents) return methods;

			for (const sc of this.structureComponents) {
					if (sc.structureComponentDetail.improvementComponentType === "ExteriorWallsAndTrim") {
							for (const ew of sc.exteriorWalls) {
									methods = h.addWithSpace(methods, ew.GetMaterialType());
							}
					}
			}

			return methods;
	}

	GetComponentConditions(type) {
			let methods = "";
			if (!this.structureComponents) return methods;

			for (const sc of this.structureComponents) {
					if (sc.structureComponentDetail.improvementComponentType === type) {
							methods = h.addWithSpace(methods, sc.GetCondition());
					}
			}

			return methods;
	}

	GetWallConditions() {
			let methods = "";
			if (!this.structureComponents) return methods;

			for (const sc of this.structureComponents) {
					if (sc.structureComponentDetail.improvementComponentType === "ExteriorWallsAndTrim") {
							methods = h.addWithSpace(methods, sc.GetCondition());
					}
			}

			return methods;
	}

	GetRoofMaterials() { // Exterior Quality
			let methods = "";
			if (!this.structureComponents) return methods;

			for (const sc of this.structureComponents) {
					if (sc.structureComponentDetail.improvementComponentType === "Roof") {
							methods = h.addWithSpace(methods, sc.roof.GetMaterials());
					}
			}

			return methods;
	}

	GetFoundationConditions() {
			let methods = "";
			if (!this.structureComponents) return methods;

			for (const sc of this.structureComponents) {
					if (sc.structureComponentDetail.improvementComponentType === "Foundation") {
							methods = h.addWithSpace(methods, sc.GetCondition());
					}
			}

			return methods;
	}

	GetFoundationMaterials() {
			let materials = "";
			if (!this.structureComponents) return materials;

			for (const sc of this.structureComponents) {
					if (sc.structureComponentDetail.improvementComponentType === "Foundation") {
							materials = h.addWithSpace(materials, sc.GetFoundationMaterials());
					}
			}

			return materials;
	}

	GetFoundationStyles() {
			let style = "";
			if (!this.structureComponents) return style;

			for (const sc of this.structureComponents) {
					if (sc.structureComponentDetail.improvementComponentType === "Foundation") {
							style = h.addWithSpace(style, sc.GetFoundationStyles());
					}
			}

			return style;
	}

	GetFoundationQuality() {
			let quality = "";
			if (!this.structureComponents) return quality;

			for (const sc of this.structureComponents) {
					if (sc.structureComponentDetail.improvementComponentType === "Foundation") {
							quality = h.addWithSpace(quality, sc.structureComponentDetail.improvementComponentQualityDescription);
					}
			}

			return quality;
	}
    GetConstructionMethods() {
        if (!this.constructionMethods) return '';
				var methods = "";
				for (const cm of this.constructionMethods)
           methods = h.addWithSpacer(methods, cm.GetMethodType());

        return methods;
    }

    GetConstructionMethodsList() {
        if (!this.constructionMethods) return [];
				var methods = [];
				for (const cm of this.constructionMethods)
           methods.push(cm.GetMethodType());

        return methods;
    }

    GetEffectiveAge() {
        if (!this.structureAnalysis) return '';

        var sad = this.structureAnalysis.structureAnalysisDetail;
        if (sad.effectiveAgeYearsCount !== null) {
            return `${sad.effectiveAgeYearsCount} years`;
        }

        return `${sad.effectiveAgeRangeLowYearsCount}-${sad.effectiveAgeRangeHighYearsCount} years`;
    }

    GetEffectiveAgeDescription() {
        if (!this.structureAnalysis) return '';
        return this.structureAnalysis.structureAnalysisDetail.effectiveAgeDescription || '';
    }

    GetRemainingLifeComment() {
        if (!this.structureAnalysis) return '';
        return this.structureAnalysis.structureAnalysisDetail.estimatedRemainingEconomicLifeDescription || '';
    }

    GetRemainingLife() {
        if (!this.structureAnalysis) return '0 years';

        const { EstimatedRemainingEconomicLifeYearsCount: years } =
            this.structureAnalysis.structureAnalysisDetail;

        return `${years || 0} years`;
    }

    GetRemainingLifeCount() {
        if (!this.structureAnalysis) return 0;

        const { EstimatedRemainingEconomicLifeYearsCount: years } =
            this.structureAnalysis.structureAnalysisDetail;

        return years ?? 0;
    }

    StructureIsRise() {
        if (!this.architecturalDesign) return false;
        var type = this.architecturalDesign.structuralDesignType;
        return ['Lowrise', 'Midrise', 'Highrise'].includes(type);
    }

    StructureIsMidHighRise() {
        if (!this.architecturalDesign) return false;
        var type = this.architecturalDesign.structuralDesignType;
        return ['Midrise', 'Highrise'].includes(type);
    }

    GetStructuralDesignTypeRaw() {
        return this.architecturalDesign?.structuralDesignType || '';
    }

    GetStructuralDesignType() {
        if (!this.architecturalDesign) return '';
        return h.descriptionOrOther(
            this.architecturalDesign.structuralDesignType,
            this.architecturalDesign.structuralDesignTypeOtherDescription
        );
    }

    GetArchitecturalDesignType() {
        if (!this.architecturalDesign) return '';
        return h.descriptionOrOther(
            this.architecturalDesign.architecturalDesignCategoryType,
            this.architecturalDesign.architecturalDesignCategoryTypeOtherDescription
        );
    }
}



